import * as types from '@/store/mutation-types'
import { requestFcmToken } from '@/plugins/firebase'
    export default {
    namespaced: true,

    state: {
        info: {},
        centerId: null,
        isAuth: false,
        core: {},
        bus: {},
        isCoreAuth: false
    },

    actions: {
        login ({ commit }, { userName, password }) {
            return window.axios.post(`/assistant/${userName}/auth`, null,
                {
                    headers: {
                        'X-Password': password || ''
                    }
                })
                .then((response) => {
                    const auth = {
                        password: password,
                        Id: response.data.Id,
                        BusNo: response.data.BusNo,
                        DriverName: response.data.DriverName,
                        DriverPhone: response.data.DriverPhone,
                        AssistantName: response.data.AssistantName,
                        CenterId: response.data.CenterId,
                        Student: response.data.Student ? response.data.Student : []
                    }
                    localStorage.setItem('isAuth', true)
                    commit(types.LOGIN, auth)
                    return auth
                })
        },

        // new driverAssistant API - JWT auth, runs alongside the legacy login above
        loginCore ({ commit }, { username, password }) {
            return requestFcmToken().then((fcmToken) => {
                return window.coreAxios.post('/auth/login', {
                    email: '',
                    username,
                    password,
                    fcmToken: fcmToken || '',
                    platform: 'web'
                })
            }).then(({ data }) => {
                commit(types.STORE_CORE_AUTH, data.data)
                return data.data
            })
        },

        refreshCoreToken ({ commit, state }) {
            return requestFcmToken().then((fcmToken) => {
                return window.coreAxios.post('/auth/refreshToken', {
                    refreshToken: state.core.refreshToken,
                    fcmToken: fcmToken || ''
                })
            }).then(({ data }) => {
                commit(types.STORE_CORE_AUTH, data.data)
                return data.data
            })
        },

        ensureFreshCoreToken ({ state, dispatch }) {
            if (!state.core.expiresAt) return Promise.resolve()
            const minutesLeft = (new Date(state.core.expiresAt).getTime() - Date.now()) / 60000
            if (minutesLeft <= 5) {
                return dispatch('refreshCoreToken')
            }
            return Promise.resolve()
        },

        hydrateCore ({ commit }) {
            const core = JSON.parse(localStorage.getItem('coreAuth'))
            const bus = JSON.parse(localStorage.getItem('busProfile'))
            if (core) commit(types.STORE_CORE_AUTH, core)
            if (bus) commit(types.STORE_BUS_PROFILE, bus)
        },

        fetchBusProfile ({ commit }) {
            return window.coreAxios.get('/driverAssistant/profile').then(({ data }) => {
                const bus = data.data[0] || {}
                commit(types.STORE_BUS_PROFILE, bus)
                return bus
            })
        },

        logout ({ commit }) {
            localStorage.removeItem('auth')
			localStorage.removeItem('isAuth')
            localStorage.clear()
			commit(types.LOGOUT)
        }
    },

    mutations: {
        [types.LOGIN] (state, payload) {
            state.info.BusNo = payload.BusNo
			state.info.DriverName = payload.DriverName
			state.info.DriverPhone = payload.DriverPhone
			state.info.CenterId = payload.CenterId
            state.info.AssistantName = payload.AssistantName
            state.info.students = payload.Student
            state.info.CenterId = payload.CenterId
            state.info.busId = payload.Id

            state.isAuth = true
			window.axios.defaults.headers['X-Password'] = payload.password
        },

        [types.STORE_CORE_AUTH] (state, payload) {
            state.core = payload
            state.isCoreAuth = true
            localStorage.setItem('coreAuth', JSON.stringify(payload))
            window.coreAxios.defaults.headers.common.Authorization = `Bearer ${payload.accessToken}`
        },

        [types.STORE_BUS_PROFILE] (state, payload) {
            state.bus = payload
            localStorage.setItem('busProfile', JSON.stringify(payload))
        },

        [types.LOGOUT] (state) {
			state.isAuth = false
			state.info = {}
            state.core = {}
            state.bus = {}
            state.isCoreAuth = false
            delete window.coreAxios.defaults.headers.common.Authorization
            localStorage.clear()
		}
    }
}
